import { version } from "@/../package.json";
import { defineVersionCheckerStore } from "@frontend/common/composables/defineVersionCheckerStore";

export const useVersionCheckerStore = defineVersionCheckerStore(version);
